export type LocationProps = Pick<
  Queries.SanityLocation,
  'title' | 'address1' | 'address2'
>;

export const getLocationProps = (
  location?: Partial<LocationProps>,
): {
  title: string | undefined;
  address1: string;
  address2: string;
} => {
  return {
    title: location?.title ?? '',
    address1: location?.address1 ?? '',
    address2: location?.address2 ?? '',
  };
};
